export default __webpack_public_path__ + "static/media/gitbook-icon.6869b98e.svg";